module.exports = __webpack_public_path__ + "static/media/Cancel_public_events_timeline.14884a6a.svg";